import React from 'react';

const CardMaestro = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" fill="none">
      <g clipPath="url(#clip0_19672_16103)">
        <path d="M0 2C0 0.895431 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V14C24 15.1046 23.1046 16 22 16H2C0.89543 16 0 15.1046 0 14V2Z" fill="#CCEFFF"/>
        <path d="M14.6245 12.718H9.375V3.28369H14.6245V12.718Z" fill="#6C6BBD"/>
        <path d="M9.71126 8C9.71126 6.08621 10.6073 4.38146 12.0027 3.28285C10.9823 2.4795 9.69447 2 8.29489 2C4.98152 2 2.29565 4.68625 2.29565 8C2.29565 11.3138 4.98152 14 8.29489 14C9.69447 14 10.9823 13.5205 12.0027 12.7171C10.6073 11.6185 9.71126 9.91379 9.71126 8Z" fill="#EB001B"/>
        <path d="M21.7045 8C21.7045 11.3138 19.0186 14 15.7053 14C14.3057 14 13.0179 13.5205 11.9971 12.7171C13.3928 11.6185 14.2889 9.91379 14.2889 8C14.2889 6.08621 13.3928 4.38146 11.9971 3.28285C13.0179 2.4795 14.3057 2 15.7053 2C19.0186 2 21.7045 4.68625 21.7045 8Z" fill="#0099DF"/>
      </g>
      <defs>
        <clipPath id="clip0_19672_16103">
          <rect width="24" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default CardMaestro;
